import { render, staticRenderFns } from "./team-member-demographic-data.vue?vue&type=template&id=6e0fcb36&scoped=true&"
import script from "./team-member-demographic-data.vue?vue&type=script&lang=ts&"
export * from "./team-member-demographic-data.vue?vue&type=script&lang=ts&"
import style0 from "./team-member-demographic-data.vue?vue&type=style&index=0&id=6e0fcb36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0fcb36",
  null
  
)

export default component.exports